import "./Contact.css";
import { useT } from "@/i18n/context";
import { company } from "@/data/company";

export function Contact() {
  const t = useT();
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact__inner" data-reveal="">
          <h2 className="contact__heading">{t.contact.heading}</h2>
          <p className="contact__body">{t.contact.body}</p>
          <a className="btn" href={`mailto:${company.email}`}>{t.contact.cta}</a>
          <p className="contact__email">{company.email}</p>
        </div>
      </div>
    </section>
  );
}

export default Contact;
